import { CREATE_SUPPORT_TICKET } from "../../CONSTANTS";

export default function createSupportTicket({
  subject,
  description,
  category,
  subcategory,
  setError,
}) {
  return {
    type: CREATE_SUPPORT_TICKET,
    payload: {
      subject,
      description,
      category,
      subcategory,
      setError,
    },
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/actions/tickets/createSupportTicket.js